import * as loadingState from '../constants/loadingState';

export const FETCH_CURRICULUM = 'FETCH_CURRICULUM';
export const FETCH_CURRICULUM_SUCCESS = 'FETCH_CURRICULUM_SUCCESS';
export const FETCH_CURRICULUM_FAILED = 'FETCH_CURRICULUM_FAILED';

export const fetchCurriculum = id => ({
  type: FETCH_CURRICULUM,
  payload: {
    id,
  },
});

export const fetchCurriculumSuccess = data => ({
  type: FETCH_CURRICULUM_SUCCESS,
  payload: {
    data,
  },
});

export const fetchCurriculumFailed = errorMessage => ({
  type: FETCH_CURRICULUM_FAILED,
  payload: {
    errorMessage,
  },
});

// reducer
const INIT_STATE = {
  loading: loadingState.EMPTY,
  data: [],
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_CURRICULUM:
      return {
        ...state,
        loading: loadingState.LOADING,
      };
    case FETCH_CURRICULUM_SUCCESS:
      return {
        ...state,
        loading: loadingState.READY,
        data: action.payload.data,
      };
    case FETCH_CURRICULUM_FAILED:
      return {
        ...state,
        loading: loadingState.ERROR,
        errorMessage: action.payload.errorMessage,
      };
    default:
      return state;
  }
};

export default reducer;

export const getCurriculums = state => state.curriculum.data;



// WEBPACK FOOTER //
// ./app/redux/curriculum.js